<template>
  <b-container>
    <div class="body-wrapper">
      <div class="body-title">
        <b-row class="no-gutters">
          <b-col>
            <h5 class="dash-heading">Dashboard</h5>
          </b-col>
          <b-col style="text-align: right">
            <!-- <div  style="float:right;margin-top:-0.7rem"><span><small> Profile Completion:</small></span>
              <b-progress :max="max" class="w-75 float-right" style="background-color: #a0a3a7;">
                <b-progress-bar :value="counter">
                 <strong>{{ counter }} / {{ max }}</strong>
                </b-progress-bar>
              </b-progress>
            </div>-->
            <b-btn
              variant="secondary"
              v-if="isLoading2"
              size="sm"
              @click="submit"
              >Create Profile</b-btn
            >
            <Spinner size="16" message="Loading..." v-if="isLoading2"></Spinner>
          </b-col>
        </b-row>
      </div>
      <div class="body-content">
        <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
        <b-alert
          :show="showDismissibleAlert"
          dismissible
          @dismissed="showDismissibleAlert = false"
          :variant="variant"
          >{{ alertText }}</b-alert
        >
        <b-card class="mb-3" v-if="notices.length>0">
          <div v-for="notice in notices" :key="notice.Header">
            <h6 style="color:red">{{notice.Header}}</h6>
            <strong style="font-size:12px">{{notice.Subheader}}</strong>
            <p style="font-size:12px">{{notice.RejectRemarks}}</p>
            <p style="font-size:12px">Date: {{notice.RemarkDate}}</p>
          </div>
        </b-card>

        <!-- <b-table show-empty head-variant="dark"
                    empty-text="No Data available"
                      stacked="md"
                      bordered
                      striped
                      :items="PersonDataScheme"
                      :fields="PersonDatafields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      @filtered="onFiltered"
                      style="font-size:12px"
                     
          >
              <template slot="details" slot-scope="row">
                   <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
                  </b-button> 
                  <a :href="s3bucketpath(row.item)" target="_blank">View</a>
              </template>    
              <template slot="action" slot-scope="row">
                   <b-button size="sm" @click.stop="applyforScheme(row.item, row.index, $event.target,4)" 
                      class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="View Details">
                      View
                  </b-button>
              </template>
        </b-table>-->

        <h4 class="dash-sec-heading">Available Schemes</h4>

        <b-row class="mb-2 dash-table-2-row">
          <b-col md="4">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Search"
                size="sm"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''" size="sm"
                  >Clear</b-btn
                >
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col></b-col>
          <b-col md="4">
            <b-form-group
              horizontal
              label="Sort"
              class="mb-0 sort-label"
              label-size="sm"
              label-cols="1"
            >
              <b-input-group>
                <b-form-select
                  v-model="sortBy"
                  :options="sortOptions"
                  size="sm"
                >
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-input-group-append>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    size="sm"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <b-table
          class="table-2"
          show-empty
          head-variant="dark"
          empty-text="No Schemes available at this time. Keep Looking this space for new schemes"
          stacked="md"
          bordered
          striped
          :items="schemes"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size: 12px"
        >
          <template v-slot:cell(details)="row">
            <!-- <b-button size="sm" @click.stop="showDetails(row.item, row.index, $event.target)" 
                      class="mr-1 pt-0 pb-0" variant="outline-success" v-b-tooltip.hover title="View Details">
                      Details
            </b-button>-->
            <a :href="s3bucketpath(row.item)" target="_blank">View</a>
          </template>
          <template v-slot:cell(action)="row">
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 1)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-success"
              v-b-tooltip.hover
              title="Eligibility for the scheme"
              >Eligibility</b-button
            >
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 2)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-info"
              v-b-tooltip.hover
              title="Guidelines for Loan Scheme"
              >Guidelines</b-button
            >

            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 4)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-danger"
              v-b-tooltip.hover
              title="View Details"
              >View</b-button
            >
            <b-button
              size="sm"
              @click.stop="
                applyforScheme(row.item, row.index, $event.target, 3)
              "
              class="mr-1 pt-0 pb-0 color-btn"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Apply for the Scheme"
              >Apply</b-button
            >
          </template>
        </b-table>
        <b-row class="dash-pagination-row">
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group
              horizontal
              label="Per page"
              class="mb-0"
              label-size="sm"
              :label-cols="6"
            >
              <b-form-select
                :options="pageOptions"
                v-model="perPage"
                size="sm"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="dash-divider"></div>
        <h4 class="dash-sec-heading">My Applications</h4>
        <table
          role="table"
          aria-busy="false"
          aria-colcount="4"
          class="
            table
            b-table
            table-striped table-bordered
            b-table-stacked-md
            dash-table-1
          "
          style="font-size: 12px"
        >
          <thead role="rowgroup" class="thead-dark">
            <tr role="row">
              <th role="columnheader">Application No.</th>
              <th role="columnheader">Application Date</th>
              <th role="columnheader">Scheme Type</th>
              <th role="columnheader">Status</th>
              <th role="columnheader">LOI</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="member in LoanApplication"
              :key="member.LoanApplicationNo"
            >
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.LoanApplicationNo }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.Createdate }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined && 
                  member.LoanApplicationNo !== ''
                "
              >
                <div v-if="member.LoanType == 1">Individual Loan</div>
                <div v-if="member.LoanType == 2">Group Loan</div>
                <div v-if="member.LoanType == 3">Education Loan</div>
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                {{ member.LoanApplicationStatus }}
              </th>
              <th
                v-if="
                  member.LoanApplicationNo !== undefined &&
                  member.LoanApplicationNo !== ''
                "
              >
                <!-- <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="submitBankDetails"
                >Submit Bank Details</b-btn>-->
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="
                    downloadLOI(
                      member.LoanApplicationID,
                      member.LoanType,
                      member.UserID
                    )
                  "
                  v-if="
                   member.ApplicationStatus == 6 ||
                    member.ApplicationStatus == 16 ||
                    member.ApplicationStatus == 8 ||
                    member.ApplicationStatus == 21 ||
                    member.ApplicationStatus == 27
                  "
                  >DownLoad LOI</b-btn
                >
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="
                    applytoExtendLOI(
                      member.LoanApplicationID,
                      member.LoanType,
                      member.UserID
                    )
                  "
                  v-if="member.ApplicationStatus == 10"
                  >Apply for Extension</b-btn
                >
              </th>
            </tr>
            <tr v-if="LoanApplication.length == 0">
              <th colspan="5" style="text-align: center">
                Not applied for any of the scheme yet.
              </th>
            </tr>
          </tbody>
        </table>

        <div class="dash-divider"></div>
        <h4 class="dash-sec-heading">My Profile</h4>
        <table
          role="table"
          aria-busy="false"
          aria-colcount="4"
          class="
            table
            b-table
            table-striped table-bordered
            b-table-stacked-md
            dash-table-1
          "
          style="font-size: 12px"
        >
          <thead role="rowgroup" class="thead-dark">
            <tr role="row">
              <th role="columnheader">Aadhar Id</th>
              <th role="columnheader">Email Address</th>
              <th role="columnheader">Mobile No.</th>
              <th role="columnheader">Profile Photo</th>
              <th role="columnheader">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ AadharId }}</th>
              <th>{{ EmailAddress }}</th>
              <th>{{ MobileNo }}</th>
              <th>
                <img
                  style="width: 60px"
                  :src="getImgUrl(personalDetails.UserDocuments.PhotoPath)"
                />
              </th>
              <th>
                <b-btn
                  variant="secondary"
                  size="sm"
                  class="dash-btn"
                  @click="submitView"
                  >View Profile</b-btn
                >
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      ref="myModalRef"
      id="modal1"
      :title="title"
      size="lg"
      scrollable
      ok-only
    >
      <SchemeEligibility
        :SchemeID="selectedSchemeId"
        v-if="btnType == 1"
      ></SchemeEligibility>
      <SchemeGuidelines
        :SchemeID="selectedSchemeId"
        v-if="btnType == 2"
      ></SchemeGuidelines>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm"
      centered
      hide-footer
      title="Incomplete Profile"
      size="sm"
    >
      <p>To view for this scheme, you need to complete your profile</p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn class="float-right" size="sm" variat="info" to="/LoginProfile"
          >Create Profile</b-btn
        >
      </div>
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm1"
      centered
      hide-footer
      title="Application Number"
      size="sm"
    >
      <p v-if="isViewEnabledP == true">
        Your Application Number is : {{ AckPNo }}
      </p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
    <b-modal
      ref="confirmApply"
      id="modalConfirm2"
      centered
      hide-footer
      title="Application Number"
      size="sm"
    >
      <p v-if="isViewEnabledG == true">
        Your Application Number is : {{ AckGNo }}
      </p>
      <hr />
      <div class="justify-content-md-center">
        <b-btn variant="link" size="sm" class="float-right" @click="hideModal"
          >Cancel</b-btn
        >
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "../apis";
import Spinner from "vue-simple-spinner";
import SchemeEligibility from "@/components/SchemeDetails/SchemeEligibility";
import SchemeGuidelines from "@/components/SchemeDetails/SchemeGuidelines";
export default {
  components: { Spinner, SchemeEligibility, SchemeGuidelines },
  data() {
    return {
      notices: [],
      personalDetails: {
        UserDocuments: {
          PhotoPath: null,
          SignaturePath: null,
          AdharCardPath: null,
          PancardPath: null,
          RationCardPath: null,
          CasteCertificate: null,
          EduCertificate: null,
          ExServiceManProof: null,
          ExprienceCertificate: null,
          BirthCertificate: null,
          PoliceVerification: null,
          MedicalCertificate: null,
          RecommendationLetter: null,
          DeceasedID: null,
          LegalHireNOC: null,
          FinalDuesLetter: null,
          CourtOrder: null,
        },
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      AadharId: "",
      EmailAddress: "",
      MobileNo: "",
      ProfilePhoto: "",
      LoanApplication: [],
      //   {
      //     LoanType: "",
      //     UserID: "",
      //     LoanApplicationID: "",
      //     LoanApplicationNo: "",
      //     SchemeType: "",
      //     GroupID: "",
      //     AmountDemanded: "",
      //     ApplicationStatus: "",
      //     AmountApproved: "",
      //     Level1Approver: "",
      //     Level1ApprovalDate: "",
      //     Level2Approver: "",
      //     Level2ApprovalDate: "",
      //     LOIDate: "",
      //     BankID: "",
      //     BankApprovalDate: "",
      //     BankLoanAmount: "",
      //     BankInterestRate: "",
      //     LoanTenure: "",
      //     LoanStartDate: "",
      //     LoanEndDate: "",
      //     LoanStatus: ""
      //   }
      // ],
      PersonDataScheme: [
        {
          SchemeID: "",
          SchemeName: "Interest Refund",
          SchemeShortName: "IR-1",
          SchemeDescription: "",
          SchemePhoto: "",
          ApplyStatus: false,
        },
      ],
      schemes: [
        {
          SchemeID: "",
          SchemeName: "Interest Refund",
          SchemeShortName: "IR-1",
          SchemeDescription: "",
          ApplyStatus: false,
          LoanType: 1,
        },
      ],
      itemsa: [],
      counter: 0,
      max: 0,
      isIndivisual: false,
      isGroup: false,
      fields: [
        { key: "SchemeShortName", label: "Scheme ID", sortable: true },
        { key: "SchemeName", label: "Scheme Name", sortable: true },
        { key: "SchemeDescription", label: "Description", sortable: true },
        { key: "action", label: "Apply" },
      ],
      PersonDatafields: [
        { key: "AdharNo", label: "Aadhar ID", sortable: true },
        { key: "EmailID", label: "Email Address", sortable: true },
        { key: "Mobile", label: "Mobile No.", sortable: true },
        { key: "SchemePhoto", label: "Profile Photo", sortable: true },
        { key: "action", label: "Apply" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedSchemeId: "00000000-0000-0000-0000-000000000000",
      selectedLoanType: 0,
      btnType: 1,
      title: "Scheme Eligibility",
      isApplyEnable: false,
      isViewEnabled: false,
      isViewEnabledP: false,
      isViewEnabledG: false,
      AckPNo: 0,
      AckGNo: 0,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log (x);
      return x;
    },
  },
  methods: {
    s3bucketpath(rowdtl) {
      return (
        "https://aws.msobcfdc.in/S3BucketApril/" +
        rowdtl.SchemeID +
        "/schemeinfo.pdf"
      );
    },
    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          userId +
          "/" +
          pic
        );
      }
    },
    showTitleDialog() {
      this.$modal.show("dialog", {
        title: "Information",
        text: "Check out, I have a title 😎",
      });
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    applyforScheme(item, index, button, n) {
      this.selectedSchemeId = item.SchemeID;
      this.selectedLoanType = item.LoanType;
      this.$store.dispatch("setScheme", {
        SchemeID: this.selectedSchemeId,
        LoanType: this.selectedLoanType,
      });
      this.btnType = n;
      if (n == 1) {
        this.title = "Scheme Eligibility";
        this.$root.$emit("bv::show::modal", "modal1", button);
      } else if (n == 2) {
        this.title = "Scheme Guidelines";
        this.$root.$emit("bv::show::modal", "modal1", button);
      } else if (n == 3) {
        if (this.isViewEnabledP == true && item.LoanType == 1) {
          this.$root.$emit("bv::show::modal", "modalConfirm1");
        } else if (this.isViewEnabledG == true && item.LoanType == 2) {
          this.$root.$emit("bv::show::modal", "modalConfirm2");
        } else {
          this.$router.push("/LoginProfile");
        }
        //   let info = "You want to delete record for:" + "\n" + item.Document;
        // this.modalInfo = info;
      } else if (n == 4) {
        if (this.isViewEnabledG == false) {
          this.$root.$emit("bv::show::modal", "modalConfirm");
        } else {
          if (item.LoanType == 2) {
            this.$router.push("/ViewGroupDetails");
          }
        }
        if (this.isViewEnabledP == false) {
          this.$root.$emit("bv::show::modal", "modalConfirm");
        } else {
          if (item.LoanType == 1) {
            this.$router.push("/ViewPresonalDetails");
          }
        }
      }
    },
    submit() {
      this.isLoading2 = true;
      this.$router.push("/profile");
    },
    submitBankDetails() {
      this.isLoading2 = true;
      this.$router.push("/BankDetails");
    },
    downloadLOI(ApplicationID, LoanType, UserID) {
      this.isLoading2 = true;
      this.$router.push({
        name: "LoanLOIPrint",
        params: {
          ApplicationID: ApplicationID,
          Loantype: LoanType,
          UserID: UserID,
        },
      });
    },
    applytoExtendLOI(ApplicationID, LoanType, UserID) {
      this.isLoading2 = true;
      var userinfo = this.$store.getters.loggedUser;
      UserID = userinfo.UserId;

      var application = {
        ApplicationStatus: 0,
        RejectReason: 0,
        Remarks: "",
        UserID: UserID,
        ApplicationID: ApplicationID,
      };

      this.$dialog
        .prompt({
          title: "Confirm LOI Extension",
          body: "You are requesting for Extending LOI Due Date, Do you want to Continue?",
        })
        .then(function (dialog) {
          return apis.ApplyforExtension(application);
        })
        .then((response) => {
          if (response != undefined) {
            if (response.status == 200) {
              this.$dialog.alert(
                "Your Request is Submitted Successfully. Please wait for further information."
              );
              this.getApplicationsSub();
            } else {
              this.$dialog.alert("Unable to save changes");
            }
          }
        })
        .catch((err) => {
          alert('Hi'+err);
          if (err != false) {
            
            this.$dialog.alert("Error while saving data");
          }
        });

      Promise.then((response) => {}).catch((err) => {});
    },
    submitView() {
      this.isLoading2 = true;
      this.$router.push("/ViewPersonalprofile");
    },
    hideModal() {
      this.$refs.confirmApply.hide();
    },
    getProfileStatus() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUsePrfileStatus(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;

            for (var x in rspns) {
              if (x != "ProfileNumber") {
                if (
                  (this.getRegTyp == 0 &&
                    x != "ExprienceDetail" &&
                    x != "PaymentStatus") ||
                  (this.getRegTyp == 3 && x != "ExprienceDetail") ||
                  this.getRegTyp == 1 ||
                  this.getRegTyp == 2 ||
                  this.getRegTyp >= 4
                ) {
                  this.max++;

                  if (rspns[x]) {
                    this.counter++;
                  }
                }
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getApplicationsSub() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      if (this.form.ApplicationStatusID == 2) {
        this.showsts = true;
      } else {
        this.showsts = false;
      }

      if (this.form.ApplicationStatusID == 1) {
        this.showbtn = true;
      } else {
        this.showbtn = false;
      }

      this.$store.dispatch("setSearchForm", this.form);
      let promise = apis.ReadApplicationList(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.applications = response.body;
            this.totalRows = this.applications.length;
            var userinfo = this.$store.getters.loggedUser;
            // if (this.form.ApplicationStatusID == 10 && userinfo.RoleID == 4) {
            //   this.showExtend = true;
            // } else {
            //   this.showExtend = false;
            // }
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      this.$refs.mdlAdvSearch.hide();
      //console.log(this.selectedDistrict);
    },
    getUserProfile() {
      var userinfo = this.$store.getters.loggedUser;
      let promiseU = apis.ReadUserDetailByIndivisual(userinfo.UserId);

      promiseU
        .then((response) => {
          if (response.status == 200) {
            //Check the profile completion status
            let rspns = response.body;
            this.AadharId = response.body.AdharNo;
            this.EmailAddress = response.body.EmailID;
            this.MobileNo = response.body.MobileNo;
            this.personalDetails.UserDocuments.PhotoPath =
              response.body.UserLoanDocuments.PhotoPath;
            if (rspns.LoanApplication.length == 1) {
              if (
                rspns.LoanApplication[0].LoanApplicationID ==
                "00000000-0000-0000-0000-000000000000"
              ) {
                this.LoanApplication = [];
              } else {
                this.LoanApplication = response.body.LoanApplication;
              }
            } else {
              this.LoanApplication = response.body.LoanApplication;
            }

            if (response.body.LoanApplication.length > 0) {
              // if (response.body.LoanApplication[0].LoanType > 0) {
              //   this.LoanApplication = response.body.LoanApplication;
              //   if (
              //     this.LoanApplication.LoanApplicationID !== undefined &&
              //     this.LoanApplication.LoanApplicationID !== ""
              //   ) {
              //     this.isViewEnabled = true;
              //   }
              //   if (
              //     this.LoanApplication.LoanApplicationID == undefined &&
              //     this.LoanApplication.LoanApplicationID == ""
              //   ) {
              //     this.isViewEnabled = true;
              //   }
              // }
              for (var i = 0; i < response.body.LoanApplication.length; i++) {
                if (
                  response.body.LoanApplication[i].LoanApplicationNo !==
                    undefined &&
                  response.body.LoanApplication[i].LoanApplicationNo !== "" &&
                  response.body.LoanApplication[i].LoanType == 1 || response.body.LoanApplication[i].LoanType == 2 || response.body.LoanApplication[i].LoanType == 3
                ) {
                  this.AckPNo =
                    response.body.LoanApplication[i].LoanApplicationNo;
                  this.$store.dispatch("setApplicationNo", this.AckPNo);
                  this.$store.dispatch(
                    "setApplicationID",
                    response.body.LoanApplication[i].LoanApplicationID
                  );
                  this.$store.dispatch(
                    "setAppStatus",
                    response.body.LoanApplication[i].ApplicationStatus
                  );
                  this.isViewEnabledP = true;
                  if (response.body.LoanApplication[i].ApplicationStatus != 3) {
                    //alert(response.body.LoanApplication[i].ApplicationStatus);
                    
                    this.$store.dispatch("lockProfile", true);
                  }
                } else if (
                  response.body.LoanApplication[i].LoanApplicationNo !==
                    undefined &&
                  response.body.LoanApplication[i].LoanApplicationNo !== "" &&
                  response.body.LoanApplication[i].LoanType == 2
                ) {
                  this.AckGNo =
                    response.body.LoanApplication[i].LoanApplicationNo;
                  this.$store.dispatch("setApplicationNo", this.AckGNo);
                  this.$store.dispatch(
                    "setApplicationID",
                    response.body.LoanApplication[i].LoanApplicationID
                  );

                  this.isViewEnabledG = true;
                
                  this.$store.dispatch("lockProfile", true);
                } else {
                  this.$store.dispatch("lockProfile", false);
                }
              }
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then((response) => {
          if (response.status == 200) {
            let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.schemes = [];
    var userinfo = this.$store.getters.loggedUser;
    this.getSchemes();
    this.getUserProfile();

    let promise = apis.readNotifications(userinfo.UserId);
    promise
      .then((response) => {
        if (response.status == 200) {
          this.notices = response.body;
        }
      })
      .catch((err) => {
        console.err(err);
      });
  },
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fff;
  border-bottom: solid 1px #d3d3d3;
}

.body-content {
  padding: 25px 10px;
}

/* Akshay 25-08-2019 */

.dash-heading {
  color: #000;
  font-weight: bold;
  font-size: 19px;
}

.body-content {
  padding-left: 25px;
  padding-right: 25px;
}
.body-wrapper {
  box-shadow: none;
  -webkit-box-shadow: none;
  padding-bottom: 0;
  margin-top: 30px;
  margin-bottom: 30px;
}

.dash-btn {
  color: #fff;
  background-color: #2e4b90;
  font-size: 11px;
  padding: 7px 20px;
  border-radius: 4px;
  font-weight: bold;
  margin-bottom: 3px;
  margin-top: 3px;
}

.dash-table-1 {
  margin-bottom: 30px;
}
.dash-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  height: 1px;
  border-bottom: 1px solid #f2f2f2;
}
.dash-sec-heading {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
}

.dash-table-2-row {
  margin-bottom: 30px !important;
  margin-top: 20px;
}

.dash-table-2-row .form-control {
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.dash-table-2-row .custom-select {
  padding-top: 8px;
  padding-bottom: 8px;
  height: auto;
  font-size: 12px;
}

.custom-select:disabled {
  background-color: #6c757d;
  color: #fff;
  border: none;
  opacity: 0.65;
}
.dash-table-2-row button {
  padding-left: 20px;
  padding-right: 20px;
}

.dash-pagination-row {
  margin-top: 20px;
}

.dash-pagination-row .page-item.active .page-link {
  background-color: #2e4b90;
  border-color: #2e4b90;
  padding-right: 10px;
  padding-left: 10px;
}

.color-btn {
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue